import React from 'react';
import Link from 'next/link';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  EventDuration,
  UserEventBody,
  StartEventTitle,
  UserEventDateContainer,
  NewEventBadge,
  UserEventAnchor,
  EventContainer,
  NewEventText
} from './style';
import { logEvent } from 'utils/eventTracking';

interface Props {
  selectedModule: string;
}

export const EventModuleMapping: Record<string, string> = {
  abstract_management: 'Abstract Management',
  poster_presentation_management: 'Event Management',
  'abstract_management+poster_presentation_management':
    'Abstract & Event Management'
};

const StartEvent = ({ selectedModule }: Props) => {
  const moduleName = EventModuleMapping[selectedModule] || '';

  return (
    <EventContainer>
      <NewEventBadge>
        <FontAwesomeIcon
          icon={faSparkles}
          color="var(--chakra-colors-yellow-40)"
        />
        <NewEventText> New Event</NewEventText>
      </NewEventBadge>
      <StartEventTitle>Untitled {moduleName} Event</StartEventTitle>
      <UserEventDateContainer>
        <EventDuration>
          Get started and start preparing your Event!
        </EventDuration>
      </UserEventDateContainer>
      <UserEventBody>
        <Link
          key="start-link"
          href={`/conference/create-event?selectedModule=${selectedModule}`}
          passHref={true}
        >
          <UserEventAnchor
            state={'view'}
            onClick={() =>
              logEvent(`USER_SIDEBAR_START_NEW_${moduleName}_SETUP_CLICKED`, {
                action: 'view',
                selectedOption: moduleName
              })
            }
          >
            Start Your Event
          </UserEventAnchor>
        </Link>
      </UserEventBody>
    </EventContainer>
  );
};

export default StartEvent;
